import React, { useState, useEffect, Fragment } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { faSuitcaseRolling } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Row } from 'reactstrap';
import Cell from './components/Cell';
import InventoryEditModal from './components/InventoryEditModal';
import {
  TableSytle,
  HorizontalContainer,
  VerticalContainer,
  CellHeader,
  CellHeader2,
} from './Layout';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { AxiosAPI } from '../../../../helpers/AxiosAPI';
import { gAPI_Ari_Room } from '../../../../constants/APIs';
import { postAPI_Update_Inventory } from '../../../../constants/APIs';
import RatesEditModal from './components/RatesEditModal';
import { NotificationManager } from '../../../../components/common/react-notifications';

const Room = ({ roomData, isEditingInventoryCell, cellText, handleTimeSlots }) => {
  const [display, setDisplay] = useState(true);
  const [style, setStyle] = useState({});

  return (
    <Fragment>
      <h1
        style={{
          display: 'block',
          marginTop: '15px',
        }}
      >
        <div
          style={{
            fontSize: '15px',
            cursor: 'pointer',
            display: 'inline-block',
          }}
          onClick={() => setDisplay(!display)}
        >
          {display ? <span>▼ </span> : <span>▶ </span>}
          <span
            style={{
              fontSize: '22px',
            }}
          >
            {roomData.roomName}
          </span>
        </div>
      </h1>
      {display &&
        <HorizontalContainer style={style}>
          <VerticalContainer>
            {/* <CellHeader>
            <FontAwesomeIcon
              icon={faSuitcaseRolling}
              style={{
                fontSize: '14px',
                marginBottom: '1px',
                marginRight: '10px',
              }}
            />
            {roomData.ratePlanName}
          </CellHeader> */}
            <CellHeader>Availability</CellHeader>
          </VerticalContainer>
          {roomData.data &&
            roomData.data.map((elem, index) => {
              return (
                <div className="ctns-xs" key={index}>
                  <Cell
                    handleTimeSlots={handleTimeSlots}
                    roomTypeId={roomData.roomTypeId}
                    text={elem.inventory}
                    rate={elem.rate}
                    timeSlot={elem.timeSlot}
                    cellText={cellText}
                    date={elem.date}
                    stopsell={elem.stopSell}
                    cta={elem.closedToArrival}
                    ctd={elem.closedToDeparture}
                    isEditingInventoryCell={isEditingInventoryCell}
                  />
                  {/* <RateCell
                  // cell's text will be the room's price
                  roomTypeId={roomData.roomTypeId}
                  ratePlanId={roomData.ratePlanId}
                  text={elem.rate}
                  rate={elem.rate}
                  date={elem.date}
                  stopsell={elem.stopSell}
                  cta={elem.closedToArrival}
                  ctd={elem.closedToDeparture}
                  isEditingInventoryCell={isEditingInventoryCell}
                  currency={elem.currency}
                  includeTax={elem.taxIncluded}
                  numberOfGuests={elem.guestCount}
                /> */}
                </div>
              );
            })}
        </HorizontalContainer>
      }
    </Fragment>
  );
};

const AriRoomsTable = ({ propertyId, startDate, endDate, currency, roomData }) => {

  /** Edit inventory & Edit bulk inventory */
  const [isEditingInventoryCell, setIsEditingInventoryCell] = useState(false);

  const [isEditingBulkInventory, setIsEditingBulkInventory] = useState(false);
  /** Edit bulk restrictions */
  const [isEditingBulkRestriction, setIsEditingBulkRestriction] = useState(
    false
  );
  const [isEditingBulkRates, setIsEditingBulkRates] = useState(
    false
  );
  const [isBulkEdit, setIsBulkEdit] = useState(false);
  const [roomlist, setRoomlist] = useState([]);
  const [ratelist, setRatelist] = useState([]);
  const [cellText, setCellText] = useState([]);
  const [updatedTimeSlots, setUpdatedTimeSlots] = useState([]);
  console.log(roomData)
  const handleTimeSlots = (e, timeSlot, date, roomTypeId) => {

    let data = updatedTimeSlots;
    console.log(e);
    if (data.length > 0 && data.filter(f => f.date === date && f.timeSlot === timeSlot
      && f.roomTypeId === roomTypeId).length > 0) {
      let val = { 'roomTypeId': roomTypeId, 'timeSlot': timeSlot, 'count': parseInt(e), date: date };
      data.filter(f => f.date === date && f.timeSlot === timeSlot
        && f.roomTypeId === roomTypeId)[0].count = parseInt(e);
    } else {
      data.push({ 'roomTypeId': roomTypeId, 'timeSlot': timeSlot, 'count': parseInt(e), date: date });
    }
    console.log(data);
    setUpdatedTimeSlots(data);
  };

  const handleUpdateTimeSlots = () => {
    AxiosAPI({
      url: `${postAPI_Update_Inventory}/meeting-rooms`,
      method: 'post',
      data: {
        propertyId,
        data: updatedTimeSlots,
      },
    }).then(res => {
      NotificationManager.success(
        "",
        "Availability updated successfully",
        3000,
        null,
        null,
        "success"
      );
    });
  }
  return (
    <div>
      <TableSytle>
        {roomData !== undefined && roomData.length > 0 && roomData.map((data, index) => (
          <Room
            handleTimeSlots={handleTimeSlots}
            cellText={cellText}
            roomData={data}
            isEditingInventoryCell={isEditingInventoryCell}
            key={index}
            currency={currency}
          />
        ))}
      </TableSytle>
      <InventoryEditModal
        toggleModal={() => {
          setIsEditingBulkInventory(!isEditingBulkInventory);
        }}
        isVisible={isEditingBulkInventory}
        roomlist={roomlist}
      />
      {/* <RestrictionsEditModal
        toggleModal={() => {
          setIsEditingBulkRestriction(!isEditingBulkRestriction);
        }}
        isVisible={isEditingBulkRestriction}
        roomlist={roomlist}
        ratelist={ratelist}
      /> */}
      <RatesEditModal
        toggleModal={() => {
          setIsEditingBulkRates(!isEditingBulkRates);
        }}
        isVisible={isEditingBulkRates}
        roomlist={roomlist}
        ratelist={ratelist}
      />
      <Row style={{ marginTop: '30px' }}>
        {/* {isEditingInventoryCell ? (
          <Button
            color="success"
            outline
            size="sm"
            onClick={() => {
              setTimeout(() => {
                window.location.reload();
              }, 300);
            }}
          >
            Confirm All
          </Button>
        ) : (
          <Button
            color="primary"
            outline
            size="sm"
            onClick={() => setIsEditingInventoryCell(!isEditingInventoryCell)}
          >
            Edit Inventory and Rate
          </Button>
        )} */}
        <Button
          color="primary"
          outline
          size="sm"
          onClick={() => handleUpdateTimeSlots()}
        >
          Update
        </Button>
        <Button
          color="secondary"
          outline
          className="ml-2"
          size="sm"
          onClick={() => setIsBulkEdit(!isBulkEdit)}
        >
          Bulk Update
        </Button>
        {/* <Button
          color="primary"
          outline
          size="sm"
          onClick={() => setIsEditingBulkRates(!isEditingBulkRates)}
        >
          Bulk Edit Rate
        </Button> */}
        {/* <Button
          color="secondary"
          outline
          size="sm"
          onClick={() => setIsEditingBulkRestriction(!isEditingBulkRestriction)}
        >
          Bulk Edit Restriction
        </Button> */}
      </Row>
      {isBulkEdit === true &&
        <InventoryEditModal
          toggleModal={() => {
            setIsBulkEdit(!isBulkEdit);
          }}
          isVisible={isBulkEdit}
          roomlist={roomData}
          timeSlots={roomData}
        />}
    </div >
  );
};

const mapStateToProps = ({ settings }) => {
  const { propertyId, currency } = settings;
  return {
    propertyId,
    currency
  };
};

export default injectIntl(connect(mapStateToProps, {})(AriRoomsTable));
